// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3cLPz","footer":"ChangeClinic_footer__3tXO2"};